/** Whether this session may use the application, against /api/auth/access. */

import { getNoContent } from "@/services/api-client";

/**
 * Resolves once the API admits this session now, and throws otherwise.
 *
 * Asked afresh each time: the session holds no admission, so a seat offered
 * since sign-in is seen at once. A refusal also passes through the client's
 * usual handling, which keeps the no-access screen up.
 */
export function checkAccess(): Promise<void> {
  return getNoContent("/auth/access");
}
